import { Dispatch, SetStateAction } from 'react';
import { useQuery, UseQueryResult } from 'react-query';

import {
  errorMessage,
  searchThreadsRoute,
  ThreadsResponse,
} from '@features/messaging';
import axiosInstance from '@server/axiosInstance';
import { getEnterpriseCalendarBlockRoute } from '../api/constants';
import { EventsByMonth, InterviewBlock } from '../types';
import { eventsKey } from '../constants';

type useGetBlockDataProps = {
  selectedId: string | number | null;
  setBlocksError?: Dispatch<SetStateAction<string>>;
  setSelectedEvent?: Dispatch<SetStateAction<InterviewBlock>>;
  setEvents: Dispatch<SetStateAction<EventsByMonth | []>>;
};

export const useGetBlockData = ({
  selectedId,
  setBlocksError = () => { },
  // setSelectedEvent,
}: useGetBlockDataProps) => {
  const {
    data: blockData,
    isFetching: isBlockLoading,
  }: UseQueryResult<InterviewBlock> = useQuery({
    queryKey: [eventsKey, selectedId],
    queryFn: () =>
      axiosInstance
        .get(getEnterpriseCalendarBlockRoute, { params: { block_id: selectedId } })
        .then((res) => res.data),
    enabled: !!selectedId,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data.status === 200) {
        // setSelectedEvent(data.object);
        setBlocksError('');
      } else {
        setBlocksError(errorMessage);
      }
    },
    onError: () => {
      setBlocksError(errorMessage);
    },
  });

  return {
    blockData,
    isBlockLoading,
  };
};
